exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ContactDashboard-data-1UDw3{margin:0;padding:0;list-style-type:none}.ContactDashboard-data-1UDw3>li{margin:5px 0}.ContactDashboard-data-1UDw3>li label{font-weight:400;color:#546d79}.ContactDashboard-rate-1QhQj{display:block;margin-top:20px;font-size:100px;font-weight:lighter;line-height:1}.ContactDashboard-rate-1QhQj.ContactDashboard-success-3q8L2{color:#00e5ce}.ContactDashboard-rate-1QhQj.ContactDashboard-warning-3xGmG{color:#faad44}.ContactDashboard-rate-1QhQj.ContactDashboard-danger-VbUyj{color:#ff5766}.ContactDashboard-count-RN2Kt{display:inline-block}.ContactDashboard-count-RN2Kt span{font-size:40px;line-height:1}.ContactDashboard-stats-kMj08{margin-top:10px;text-align:center;color:#546d79}.ContactDashboard-stats-kMj08 .ContactDashboard-count-RN2Kt{display:table-cell;width:1%}.ContactDashboard-stats-kMj08 .ContactDashboard-count-RN2Kt>span{display:block}.ContactDashboard-stats-kMj08 .ContactDashboard-count-RN2Kt small{display:block;font-size:16px}.ContactDashboard-interventionTimelimitRate-x6jNG,.ContactDashboard-repairTimelimitRate-KlL1C{text-align:center}", ""]);

// exports
exports.locals = {
	"data": "ContactDashboard-data-1UDw3",
	"rate": "ContactDashboard-rate-1QhQj",
	"success": "ContactDashboard-success-3q8L2",
	"warning": "ContactDashboard-warning-3xGmG",
	"danger": "ContactDashboard-danger-VbUyj",
	"count": "ContactDashboard-count-RN2Kt",
	"stats": "ContactDashboard-stats-kMj08",
	"repairTimelimitRate": "ContactDashboard-repairTimelimitRate-KlL1C",
	"interventionTimelimitRate": "ContactDashboard-interventionTimelimitRate-x6jNG"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/provider/components/ContactDashboard.less
// module id = 1705
// module chunks = 0